import React from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import Toggle from '../Toggle';
import { Brands } from '../../common/constants';

const Container = styled.div.attrs({ className: 'ui__list-toggle-item' })`
  ${(props) => `
    padding: ${props.theme.borders.box ? props.theme.whitespace.small : 0} 0 0 0;
    border: ${props.theme.borders.box};
    margin-bottom: ${props.theme.whitespace.gutter};
  `} box-sizing: border-box;
  background: white;
  &:last-child {
    margin-bottom: -1px;
  }
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: ${(props) =>
    props.border ? `1px solid ${props.theme.colours.border}` : 0};
  align-items: center;
  padding: 0 15px 10px 15px;
  `;
const Addon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const Label = styled.label`
    width:100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;  
`;


const PrimaryText = styled.h3`
  ${(props) => props.theme.type.h3};
  flex: 1;
`;

const SecondaryText = styled.div`
  padding: 0 15px 10px 15px;
  ${(props) => props.brand === Brands.Wireless && props.theme.type.descriptionXs}
  @media (min-width: 480px) {
    ${(props) => props.brand === Brands.Wireless && props.theme.type.descriptionSm}
  }
`;

const ListToggleItem = ({ primary, secondary, brand, checked, onClick, name, className }) => (
  <Container className={`listToggleItem ${  className}`}>
    <Wrap className="listToggleItem-wrap" border={!!secondary}>
      <Label>
        <PrimaryText>{primary}</PrimaryText>
        <Addon>
          <Toggle brand={brand} label={name} checked={checked} onChange={onClick} />
        </Addon>
      </Label>
    </Wrap>
    {secondary.length > 0 && <SecondaryText brand={brand} className="list-toggle-item-secondary">{parse(secondary)}</SecondaryText>}
  </Container>
);

ListToggleItem.propTypes = {
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.string,
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  name: PropTypes.string,
  className: PropTypes.string,
  brand: PropTypes.string.isRequired
};

ListToggleItem.defaultProps = {
  secondary: '',
  checked: false,
  onClick: () => {},
  name: null,
  className: ''
  // brand: ''
};

export default ListToggleItem;
